import { render, staticRenderFns } from "./MarqueeDzp.vue?vue&type=template&id=a48b7db6&scoped=true&"
import script from "./MarqueeDzp.vue?vue&type=script&lang=js&"
export * from "./MarqueeDzp.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeDzp.vue?vue&type=style&index=0&id=a48b7db6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b7db6",
  null
  
)

export default component.exports